import { GAME_STATE } from "../../Helpers/constants";
import { GAME_DATA_ACTIONS } from "../Actions/gameDataActions";
import { COMMAND_BOX_FLAG } from "../../Components/CommandBox";
import fightDataReducer from "../Reducers/fightDataReducer";
import { modalReducer } from "./modalReducer";
import { log } from "../../Helpers/logger";

const GAME_DATA_INITIAL_STATE = {
    gameState: GAME_STATE.ONGOING,
    commandBoxFlag: COMMAND_BOX_FLAG.MOVE,
    fightData: fightDataReducer(),
    displayModal: { 
        show: false, 
        flag: null, 
        data: {},
    }, 
    oldGameState:null,
    inCity: false,
    cityData: null,
    eventData: null,
};

const gameDataReducer = (state = GAME_DATA_INITIAL_STATE, action) => {
    // log.reducer.log(state, action);
    switch (action.type) {
        case GAME_DATA_ACTIONS.SET_GAME_STATE: {
            const { gameState } = action.payload;
            let nextState = {
                ...state,
                gameState,
                oldGameState: state.gameState
            }

            return nextState;
        }
        case GAME_DATA_ACTIONS.SET_COMMAND_BOX_FLAG: {
            const { commandBoxFlag } = action.payload;
            let nextState = {
                ...state,
                commandBoxFlag,
            }

            return nextState;
        }
        case GAME_DATA_ACTIONS.SET_TO_FIGHT_MODE: {
            return {
                ...state,
                gameState: GAME_STATE.FIGHT,
                commandBoxFlag: COMMAND_BOX_FLAG.FIGHT,
                oldGameState: state.gameState
            }
        }
        case GAME_DATA_ACTIONS.SET_TO_NORMAL_MODE: {
            return {
                ...state,
                gameState: GAME_STATE.ONGOING,
                commandBoxFlag: COMMAND_BOX_FLAG.MOVE,
                oldGameState: state.gameState
            }
        }
        case GAME_DATA_ACTIONS.SET_TO_VICTORY_MODE: {
            return {
                ...state,
                gameState: GAME_STATE.VICTORY,
                commandBoxFlag: COMMAND_BOX_FLAG.WAITING,
                oldGameState: state.gameState
            }
        }
        case GAME_DATA_ACTIONS.SET_CITY_DATA: {
            const { cityData } = action.payload;
            return {
                ...state,
                cityData
            }
        }
        case GAME_DATA_ACTIONS.SET_EVENT_DATA: {
            const { eventData } = action.payload;
            return {
                ...state,
                eventData
            }
        }
        case GAME_DATA_ACTIONS.SWITCH_BACK_TO_OLD_GAME_STATE: {
            return {
                ...state,
                gameState: state.oldGameState,
                oldGameState: state.gameState
            }
        }
        case GAME_DATA_ACTIONS.GENERATE_FIGHT_DATA: {
            const { monsterIds, monsters } = action.payload;
            log.reducer.log(monsterIds, monsters);

            const fightMonsters = monsterIds.map(monsterId => {
                const monster = monsters[monsterId];
                return {
                    ...monster,
                    stats: { ...monster.stats },
                    attack: { ...monster.attack },
                    position: { ...monster.position }
                };
            })
            // log.reducer.log(fightMonsters);

            return {
                ...state,
                fightData: {
                    ...state.fightData,
                    monsters: fightMonsters
                }
            }
        }
        case GAME_DATA_ACTIONS.SET_FIGHT_DATA_CURRENT_SELECTED_MONSTERS_INDEX: {
            const { monstersIndex } = action.payload;

            const nextFightData = {
                ...state.fightData,
                currentMonstersIndex: monstersIndex
            }
            
            return {
                ...state,
                fightData: nextFightData
            }
        }
        case GAME_DATA_ACTIONS.FIGHT_DATA.MONSTER_TAKE_DAMAGE_BY_ID:
        case GAME_DATA_ACTIONS.FIGHT_DATA.REMOVE_MONSTER_BY_INDEX:
        case GAME_DATA_ACTIONS.FIGHT_DATA.SET_END_FIGHT_DATA: {
            return {
                ...state,
                fightData: fightDataReducer(state.fightData, action),
            }
        }
        case GAME_DATA_ACTIONS.MODAL_DATA.SWITCH: 
        case GAME_DATA_ACTIONS.MODAL_DATA.SET_DATA:
        case GAME_DATA_ACTIONS.MODAL_DATA.SET_FLAG:
        case GAME_DATA_ACTIONS.MODAL_DATA.SET: {
            return {
                ...state,
                displayModal: modalReducer(state.displayModal, action),
            }
        }
    }
    return state;
}


export default gameDataReducer;